import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { useMinLoading } from '@/hooks/use-min-loading';
import { useCreatorFilters } from '../hooks/use-creator-filters';
import { TableContent } from './creators-table-content';
import { TableFooter } from './table-footer';

type Props = {
  creators: Creator[];
  totalPages: number;
  totalItems: number;
  isFetching: boolean;
  onSelect: (id: string) => void;
};

export function CreatorsTable(p: Props): ReactNode {
  const { page, setPage } = useCreatorFilters();
  const showSkeleton = useMinLoading(p.isFetching);
  return (
    <div className="overflow-hidden rounded-xl bg-white/[0.02]">
      <div className="overflow-x-auto">
        <TableContent
          creators={p.creators}
          totalItems={p.totalItems}
          onSelect={p.onSelect}
          showSkeleton={showSkeleton}
        />
      </div>
      <TableFooter
        page={page}
        totalPages={p.totalPages}
        totalItems={p.totalItems}
        onPageChange={setPage}
      />
    </div>
  );
}
